export default __webpack_public_path__ + "static/media/finishing-2.232aa827.webp";